import { useEditingStateWithCtx } from '@/atoms'
import { FormActionButton } from '@workwave-tidal/core/form'

import { useTexts } from '../../hooks/useTexts'
import { useGeneratePreviewUrl } from '../hooks/useGeneratePreviewUrl'

import { form } from '../formState'

import { useTrackingPagePreviewModal } from '@/components/modals/TrackingPagePreviewModal'

export function Footer() {
  const { resetEditing } = useEditingStateWithCtx('settings')
  const texts = useTexts()

  const { Modal, show } = useTrackingPagePreviewModal()
  const { previewUrl, generatePreviewUrl, generatingPreviewUrl } = useGeneratePreviewUrl(show)

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const saveDisabled = status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.cancel}
        size="medium"
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
        onClick={resetEditing}
      />
      <FormActionButton
        label={texts.preview}
        size="medium"
        testId="footer-preview-button"
        data-trackid="footer-preview-button"
        onClick={generatePreviewUrl}
        loading={generatingPreviewUrl}
        disabled={submitting || validating || status === 'invalid'}
      />
      <FormActionButton
        size="medium"
        type="submit"
        label={texts.save}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
        variant="contained"
        loading={submitting || validating}
        disabled={saveDisabled}
      />

      {previewUrl && <Modal previewUrl={previewUrl} />}
    </>
  )
}
